import React from 'react'
import FinishDocumentsPanel from "./FinishDocumentsPanel";

function Index(
    {
        expanded,
    }) {
    return (expanded && <FinishDocumentsPanel/>)
}


export default Index;